<template>
    <!-- CustomerSearchItem.vue -->
    <base-search-item :to="customerUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {CUSTOMER_ICON} from '@/store/static/base-icons'
    import {CUSTOMER} from '@/router/customer/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'CustomerSearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The list item icon
             */
            icon: {
                type: String,
                default: CUSTOMER_ICON
            }
        },
        computed: {
            customerUrl () {
                const vm = this
                return {
                    name: CUSTOMER,
                    params: {
                        customerId: vm.item.id
                    }
                }
            }
        }
    }
</script>
